import { createContext, useContext } from "react";

type Callback = () => void;

export const EditRideDialogContext = createContext<{
    registerOpenDialogCallback: (
        rideIndex: number,
        athleteId: string,
        callback: Callback,
    ) => void;
    triggerOpenDialog: (rideIndex: number, athleteId: string) => void;
}>({
    registerOpenDialogCallback: () => {},
    triggerOpenDialog: () => {},
});

export const useEditRideDialogContext = () => {
    const context = useContext(EditRideDialogContext);

    return context;
};
